{
	"label": "Sporbarhet av karbonbesparelser",
	"title": "Sporbarhet av karbonbesparelser",
	"paragraph": "Karbonsparing kan lagres sikkert på en blokkjede, noe som sikrer åpenhet og sporbarhet. Ved å utnytte blokkjedeteknologi kan hver karbonbesparende transaksjon registreres og verifiseres på en desentralisert og uforanderlig måte. Dette muliggjør et pålitelig og kontrollerbart system der utslippsreduksjoner kan spores nøyaktig og redegjøres for. Det betyr at en transaksjon for samme 1 karbonkreditt, ikke kan gjøres flere ganger.",
	"close": "Lukk"
}
